const resource = 'api';
export default ($http) => ({
  login(userDetails) {
    return $http.post(`${resource}/login`, userDetails);
  },
});
